import { registerQuery } from 'data-fetching-client';
import { getInsightsClient } from 'marketplace-ui-common/clients/insightsClient';
export const USER_INSIGHTS_QUERY_FIELD_NAME = 'userInsights';
export const GET_USER_INSIGHTS = registerQuery({
  fieldName: USER_INSIGHTS_QUERY_FIELD_NAME,
  args: ['appContext'],
  fetcher: ({
    appContext
  }) => getInsightsClient(appContext).get(`/insights/user-insights`)
});